export const vendors = [
  { id: "1", service: "Team Uniforms", vendor: "Quality Resource Group", contactName: "Greg Allen",
    email: "greg.allen@quality-resource.com", phoneNumber: "651.208.1355",
    website: "https://qrg.four51ordercloud.com/planetsmoothie/catalog", category: "Uniforms" },
  { id: "2", service: "Adversail Flags/Tent/Table Covers", vendor: "Convergent Print", contactName: "Nicole Butcher",
    email: "nicole.butcher@mtygroup.com; gabrielle.moxley@mtygroup.com", phoneNumber: "602.892.4786",
    website: "https://planetsmoothie.convergentprint.com/", category: "Outdoor Items" },
  { id: "3", service: "Cooler covers", vendor: "Quality Resource Group", contactName: "Greg Allen",
    email: "greg.allen@quality-resource.com", phoneNumber: "651.208.1355",
    website: "https://qrg.four51ordercloud.com/planetsmoothie/catalog", category: "Outdoor Items" },
  { id: "4", service: "Coupons, to-go menus, signs for a-frame holder", vendor: "Riot", contactName: "",
    email: "atlanta@riotcolor.com", phoneNumber: "404.873.5911",
    website: "https://planetsmoothie.myprintdesk.net/", category: "Print Materials" },
  { id: "5", service: "Direct Mail", vendor: "Grow Mail", contactName: "Mark Swan",
    email: "marks@growmail.com", phoneNumber: "727.202.4280",
    website: "https://www.growmail.com/", category: "Direct Marketing/Media" },
  { id: "6", service: "Direct Mail", vendor: "Valassis", contactName: "Debbie Niotta",
    email: "drniotta@valassis.com", phoneNumber: "909.215.7582",
    website: "https://www.rrd.com/", category: "Direct Marketing/Media" },
  { id: "7", service: "Loyalty Program (Mobile Messaging)", vendor: "SpendGo", contactName: "Nicole Butcher",
    email: "nicole.butcher@mtygroup.com; gabrielle.moxley@mtygroup.com", phoneNumber: "602.892.4786",
    website: "https://dashboard.spendgo.com/", category: "Direct Marketing/Media" },
];

export const VENDOR_CATEGORY_ORDER = ["Uniforms", "Outdoor Items", "Print Materials", "Direct Marketing/Media"];
